import { DatePipe } from '@angular/common';
import moment from 'moment';
import { isToday, isYesterday } from '../date.utils';

export const groupHistoryByDate = (
  dtCreated: Date,
  datePipe: DatePipe
): string => {
  let dtCreatedStr: string = moment(dtCreated).format();
  let today = isToday(dtCreated);
  let yesterday = isYesterday(dtCreated);

  if (today) return 'Hoje';
  if (yesterday) return 'Ontem';

  return dateToFullDate(dtCreatedStr, datePipe);
};

const dateToFullDate = (dtCreatedStr: string, datePipe: DatePipe): string => {
  const dateFormated = datePipe.transform(dtCreatedStr, 'E dd MMMM YYYY');
  if (dateFormated) {
    const dtSplited: string[] = dateFormated.split(' ');
    dtCreatedStr =
      dtSplited[0].charAt(0).toUpperCase() +
      dtSplited[0].slice(1) +
      ' ' +
      dtSplited[1] +
      ' de ' +
      dtSplited[2] +
      ' de ' +
      dtSplited[3];
    return dtCreatedStr;
  } else {
    return '';
  }
};
